<template>
    <div class="replace">
        <el-dialog title="提示" width="25%" :visible.sync="visible">
            <div class="flex flex-align-center">
                <img src="@/assets/public/warning-org.png" class="warn_img" alt="">
                <span class="ml-10 fz-14" v-if="!type">一个子账号仅支持一个微信号接收消息提醒，是否确认设置【{{ nick_name }}】为接收微信消息提醒的微信号？</span>
                <span class="ml-10 fz-14" v-else>关闭后【{{ nick_name }}】将无法接收到微信通知，是否确认关闭？</span>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">关 闭</el-button>
                <el-button type="primary" @click="confirm">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { acceptOn, acceptOff } from '@/api/personal';
export default {
    name: 'replace',
    components: {
        
    },
    data() {
        return {
            visible: false,
            nick_name:'',
            row: {},
            type: 0
        }
    },
    methods: {
        show(row, name, type) {
            this.type = type
            this.row = row
            this.nick_name = name
            this.visible = true
        },
        async confirm() {
            if(!this.type) {
                const {code} = await acceptOn({account_wechat_id: this.row.account_wechat_id})
                if(code === 0) {
                    this.$message.success('开启成功')
                    this.visible = false
                    this.$emit('switchChange', this.row)
                }
            }else {
                const {code} = await acceptOff({account_wechat_id: this.row.account_wechat_id})
                if(code === 0) {
                    this.$message.success('关闭成功')
                    this.visible = false
                    this.$emit('switchChange', this.row)
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.warn_img{
    width: 16px;
    height: 16px;
}
</style>